import { Style } from "../../globalTypes";

export const usePortfolioPageStyle = (): Style => {
  return {};
};
